import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, RouterModule } from "@angular/router";
import { IBusinessFunction } from "../../interfaces/ibusinessfunction";
import { IAppStore } from "../../iappstore";
import { Store } from "@ngrx/store";
import { SetSelectedBusinessFunctionAction, ClearSelectedBusinessFunctionAction, SetUserDetailsAction } from "../../actions/applicationuser.action";
import { AppUserService } from "../../services/appuser.service";
import { IUser } from "../../interfaces/ilogin";
import { UserRoleToggleDirective } from "../../directives/userroletoggle.directive";
import { TooltipModule } from "ngx-bootstrap/tooltip";

@Component({
    selector:"businessfunctionselection",
    standalone: true,
    imports: [CommonModule, RouterModule, UserRoleToggleDirective, TooltipModule],
    templateUrl: "./businessfunctionselection.component.html",
})
export class BusinessFunctionSelectionComponent {
    businessFunctions: IBusinessFunction[] = [];
    isSuperAdmin: boolean;
    constructor(
        private store: Store<IAppStore>,
        private router: Router,
        private appUserService: AppUserService) {
    }

    ngOnInit(): void {
        this.store.dispatch(new ClearSelectedBusinessFunctionAction());
        this.store.select(e => e.user.businessFunctions)
            .subscribe(e => {
                // Create a copy of the array before sorting since NgRx arrays are read-only
                this.businessFunctions = [...e];
                this.businessFunctions.sort((a: IBusinessFunction, b: IBusinessFunction): number => {
                    if (a.displayName < b.displayName) {
                        return -1;
                    }
                    if (a.displayName > b.displayName) {
                        return 1;
                    }
                    return 0;
                });
            });
        this.store.select(e => e.user)
            .subscribe(r => {
                if (r.roles.find(ro => ro === "SuperAdmin")) {
                    this.isSuperAdmin = true;
                }
            });
    }

    setBusinessFunction(businessFunction: IBusinessFunction): void {
        
        this.store.dispatch(new SetSelectedBusinessFunctionAction(businessFunction));

        this.appUserService.getUser().subscribe((user: IUser) => {
            // Transform roles to string array if they exist
            let transformedRoles: string[] = [];
            if (user.roles && Array.isArray(user.roles)) {
                transformedRoles = user.roles.map((e: any) => {
                    return e.name || e;
                });
            }

            // Create a new user object with transformed roles
            const userWithTransformedRoles: IUser = {
                ...user,
                roles: transformedRoles
            };

            this.store.dispatch(new SetUserDetailsAction(userWithTransformedRoles));
            this.store.dispatch(new SetSelectedBusinessFunctionAction(businessFunction));
            this.router.navigate(["/home"]);
        });
    }

    addNewBusinessFunction(): void {
        this.router.navigate(["/businessfunction"]);
    }
}
